import {useState, useEffect} from 'react';
import {decreaseFreePlagiarismAttempts, updateText} from 'requests';
import {paramsGet} from 'utils';
import {FreePremiumForm} from './FreePremiumModal';
import {IncreaseLimitsForm} from './IncreaseLimitsModal';
import {QuestionareeForFreePremium} from './QuestionareeForFreePremium';
import {PremiumActivatedModal} from '../PremiumActivatedModal';
import {Button} from 'pages/application/Login';
import {Checkbox} from '../checkbox';
import {InfoIcon} from '../icons';
import {InfoTooltip, OnboardingTooltip} from '../tooltip';
import {PermissionGuardModal} from '../PermissionGuardModal';
import {useNavigate} from 'react-router-dom';
import {useStores} from "stores/root";
import {observer} from "mobx-react-lite";


export const TextareaControll: React.FC = observer(() => {
    const {input, onboarding} = useStores();

    const {text, aiScan, deepAiScan, updated} = input;

    const [prevText, setPrevText] = useState('');
    const {user: userStore, plagiarism: plagiarismStore} = useStores()
    const [questionnaireModalOpened, setQuestionnaireModalOpened] = useState(false);
    const [premiumActivatedModalOpened, setPremiumActivatedModalOpened] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        onboarding.startOnboarding();
        input.setPlagiarism(paramsGet('plagiarism') === 'true')
        input.setAiScan(paramsGet('aiScan') === 'true')
        input.setDeepAiScan(paramsGet('deepAiScan') === 'true')

        if (!input.aiScan && !input.deepAiScan && !input.plagiarism) {
            input.setAiScan(true)
        }
    }, []);
    const [tooltipOpened, setTooltipOpened] = useState(false);
    useEffect(() => {
        if (Math.abs(text.length - prevText.length) === 1) {
            input.setUpdated(true);
        }
        if (text.length === 0) {
            input.setUpdated(false);
        }
        setPrevText(text);
    }, [text]);


    useEffect(() => {
        if (updated && input.textId !== -1) {
            updateText(input.textId.toString(), text);
            input.setUpdated(false);
        }
    }, [updated]);

    return <div className="textarea__controll">
        <PremiumActivatedModal
            open={premiumActivatedModalOpened}
            onExplore={() => {
                setPremiumActivatedModalOpened(false)
            }}
            onClose={() => {
                setPremiumActivatedModalOpened(false)
            }}
        />
        <QuestionareeForFreePremium
            open={questionnaireModalOpened}
            onOk={() => {
                setQuestionnaireModalOpened(false);
                userStore.enroll().then(() => {
                    setPremiumActivatedModalOpened(true);
                });
            }}
            onCancel={() => setQuestionnaireModalOpened(false)}
        />
        <FreePremiumForm
            open={input.freePremiumModalOpened}
            onOk={() => {
                input.setFreePremiumModalOpened(false);
                setQuestionnaireModalOpened(true);
            }}
            onCancel={() => input.setFreePremiumModalOpened(false)}
        />
        <IncreaseLimitsForm
            open={input.wordsModalOpened}
            onOk={() => input.setWordsModalOpened(false)}
            onCancel={() => input.setWordsModalOpened(false)}
        />
        <PermissionGuardModal
            open={input.showPlagiarismGuardModal}
            onClose={() => input.setShowPlagiarismGuardModal(false)}
            onUpgrade={() => {
                navigate('/main/subscription');
            }}
            alertText={"Plagiarism is a premium feature."}
        />

        <div className="fd__btns">
            <div className='fd__btns-checkboxes'>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <Checkbox data-testid="scan-checkbox" active={aiScan} onClick={() => {
                        input.setAiScan(!aiScan);
                        input.setDeepAiScan(false);
                        const url = new URL(window.location.href);
                        if (!aiScan) {
                            url.searchParams.set('aiScan', 'true');
                            url.searchParams.delete('deepAiScan');
                        } else {
                            url.searchParams.delete('aiScan');
                        }
                        window.history.replaceState({}, '', url.toString());
                    }}/>
                    <div className='fd__btns-checkboxes-text'>AI scan</div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <Checkbox data-testid="deep-scan-checkbox" active={deepAiScan} onClick={() => {
                        input.setDeepAiScan(!deepAiScan);
                        input.setAiScan(false);
                        const url = new URL(window.location.href);
                        if (!deepAiScan) {
                            url.searchParams.set('deepAiScan', 'true');
                            url.searchParams.delete('aiScan');
                        } else {
                            url.searchParams.delete('deepAiScan');
                        }
                        window.history.replaceState({}, '', url.toString());
                    }}/>
                    <div className='fd__btns-checkboxes-text'>Deep AI scan</div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <Checkbox active={input.plagiarism} onClick={input.selectPlagiarism.bind(input)}/>
                    <div className='fd__btns-checkboxes-text'>Plagiarism</div>
                </div>
                <InfoTooltip isVisible={tooltipOpened}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}
                         onMouseEnter={() => setTooltipOpened(true)}
                         onMouseLeave={() => setTooltipOpened(false)}>
                        <InfoIcon/>
                    </div>
                </InfoTooltip>
            </div>
            <OnboardingTooltip id={1}>
                <Button data-testid={"run-scan"} className='primary fd__button' onClick={() => {
                    input.sendDataToBackend(deepAiScan);
                    if ((userStore.user as any).free_plagiarism_attempts > 0) {
                        decreaseFreePlagiarismAttempts();
                    }
                    if ((userStore.user as any).free_plagiarism_attempts <= 0 && !(userStore.user as any).can_create_plagiarism_request) {
                        input.setShowPlagiarismGuardModal(true);
                        return;
                    }
                    input.setActiveSection("Plagiarism");
                    if (!input.plagiarism && (deepAiScan || aiScan)) {
                        input.setActiveSection("AI");
                    }
                }} disabled={(!aiScan && !deepAiScan && !input.plagiarism) || input.loadingAI || input.loadingPlagiarism}>
                    Run scan
                </Button>
            </OnboardingTooltip>
        </div>
    </div>
})